import { Box, Stack } from "@mui/material";
import { LoadedContent } from "components/common/loading/loadedContent";
import {
  DELIVERIES_DATE_RANGE_CONFIG,
  DateRangeProvider,
  useDateRange,
} from "contexts/DateRangeContext";
import { useStringQueryParamState } from "hooks/useStringQueryParamState";
import { ToggleSelector } from "../ToggleSelector";
import { ByMaterialDeliveries } from "./ByMaterialDeliveries";
import { DeliveriesOverview } from "./DeliveriesOverview";
import { DeliveriesPaceOverview } from "./DeliveriesPaceOverview";
import { useStrategyDashboardDeliveries } from "./deliveriesHooks";

type DeliveriesViewMode = "overview" | "timeline" | "byMaterial";

const VIEW_MODE_LABELS: Record<DeliveriesViewMode, string> = {
  overview: "overview",
  timeline: "timeline",
  byMaterial: "byMaterial",
};

export const DeliveriesTab = () => (
  <DateRangeProvider config={DELIVERIES_DATE_RANGE_CONFIG}>
    <DeliveriesTabContent />
  </DateRangeProvider>
);

const DeliveriesTabContent = () => {
  const [viewMode, setViewMode] = useStringQueryParamState<DeliveriesViewMode>(
    "deliveriesView",
    "overview"
  );

  return (
    <Stack spacing={2} sx={{ width: "100%", height: "100%", pt: 3 }}>
      <Box>
        <ToggleSelector<DeliveriesViewMode>
          selectedValue={viewMode}
          setSelectedValue={setViewMode}
          availableValueLabels={VIEW_MODE_LABELS}
        />
      </Box>
      {viewMode === "overview" ? (
        <DeliveriesPaceOverview />
      ) : (
        <RangeDeliveriesView viewMode={viewMode} />
      )}
    </Stack>
  );
};

const RangeDeliveriesView = ({
  viewMode,
}: {
  viewMode: "timeline" | "byMaterial";
}) => {
  const { startDate, endDate } = useDateRange();
  const data = useStrategyDashboardDeliveries(
    startDate.format(),
    endDate.format()
  );

  return (
    <LoadedContent data={data}>
      {(loaded) =>
        viewMode === "byMaterial" ? (
          <ByMaterialDeliveries groupedDeliverySeries={loaded} />
        ) : (
          <DeliveriesOverview groupedDeliverySeries={loaded} />
        )
      }
    </LoadedContent>
  );
};
